import { Table, TableBody, TableHead, TableRow } from '@material-ui/core';
import { HeaderTableCellX } from 'framework/table/HeaderTableCellX';
import { SortableHeaderTableCellX } from 'framework/table/SortableHeaderTableCellX';
import { IQueryResult, ISale, ISortParams } from 'gen/ApiClient';
import { useLocalization } from 'localization/useLocalization';
import React from 'react';
import { SalesTableRow } from './SalesTableRow';
import { NoContentTableHeadX } from 'framework/table/NoContentTableHeadX';

interface IProps {
	queryResult: IQueryResult<ISale>;
	sortParams: ISortParams<ISale>;
	onFilter: (sp: ISortParams<ISale>) => void;
	expandedId: string | undefined;
	expandAll: boolean;
	toggle: (id: string) => void;
}

export const SalesTable = ({ queryResult, sortParams, onFilter, expandedId, expandAll, toggle }: IProps) => {
	const strings = useLocalization();

	return (
		<Table stickyHeader>
			{queryResult.unfilteredCount === 0 && <NoContentTableHeadX>{strings.noSalesRegisteredYet}</NoContentTableHeadX>}
			{queryResult.unfilteredCount > 0 && (
				<TableHead>
					<TableRow>
						<SortableHeaderTableCellX<ISale>
							isFirst
							forProperty='reference'
							sortParams={sortParams}
							onFilter={onFilter}>
							{strings.reference}
						</SortableHeaderTableCellX>
						<SortableHeaderTableCellX<ISale>
							forProperty='created'
							sortParams={sortParams}
							onFilter={onFilter}>
							{strings.date}
						</SortableHeaderTableCellX>
						<HeaderTableCellX>{strings.customerSingularOrPlural}</HeaderTableCellX>
						<SortableHeaderTableCellX<ISale>
							forProperty='priceInVat'
							onFilter={onFilter}
							sortParams={sortParams}
							align='right'>
							{`${strings.totalAmount} (${strings.inVatShort})`}
						</SortableHeaderTableCellX>
						<HeaderTableCellX isLast></HeaderTableCellX>
					</TableRow>
				</TableHead>
			)}
			<TableBody>
				{queryResult.values.map(t => (
					<SalesTableRow
						key={t.id}
						item={t}
						isExpanded={expandedId === t.id || expandAll}
						toggle={() => toggle(t.id)}
					/>
				))}
			</TableBody>
		</Table>
	);
};
